import React from "react";
import {Redirect, Route} from "react-router-dom";

import {isAuthenticated} from "../../utils/Utils";

/**
 * For pages that only make sense while signed out (login). An admin who still
 * has a valid session goes to the dashboard instead of the login form again.
 */
export default function PublicRoute({children, render, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated() ? (
                    <Redirect to="/"/>
                ) : render ? (
                    render(props)
                ) : (
                    children
                )
            }
        />
    );
}
